











import loginPC from "./patternPC/index.vue";
import loginH5 from "./patternH5/index.vue";
import { setup } from "../../utils/devicePlatform";
import Vue from "vue";
export default {
  name: "aiwen-login",
  data() {
    return {
      platformMes: {
        appVersion: "",
        systemVersion: "",
        platform: "h5",
        device: "browser",
        adapterMobile: false
      },
    };
  },
  components: {
    "login-pc": loginPC,
    "login-h5": loginH5,
  },
  created() {
    (this as any).platformMes = setup();
  },
};
